import { useSearchParams, Link } from "react-router-dom";
import { AppBar, Toolbar, Box, ContainerBox, Typography, Button } from "@mui/material";


const OrderCancel = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");






  return (
    <Box sx={{ textAlign: "center", py: 10 }}>

  <AppBar position="static" color="primary">
        <Toolbar sx={{ justifyContent: "center" }}>
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <img
              src="/logo192.png"
              alt="BGIC Logo"
              style={{ height: 50, marginRight: 16 }}
            />
            <Typography variant="h6" component="div" fontWeight={600}>
              BGIC Digital Store
            </Typography>
          </a>
        </Toolbar>
      </AppBar>

      <Typography variant="h3" color="warning.main" gutterBottom>
        ⚠️ Payment Cancelled
      </Typography>
      <Typography variant="h6" gutterBottom>
        Your payment for order #{orderId} was cancelled.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
      >
        Back to Store
      </Button>
    </Box>
  );
};

export default OrderCancel;
